var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"green","dark":"","fixed":"","bottom":"","right":"","fab":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-cloud-download-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }